/**
 * 需在使用页面导入使用
 * import elForm from "@/utils/elForm"
 * mixins: [elForm]
 * 需要在当前使用页面注入请求路径moduleUrl
 * moduleUrl: "/scit-ig/system/role"
 * formProps等组件配置使用v-bind绑定
 * <el-form v-bind="formProps">
 * dialog标题使用:title="dialogTitle"
 * 弹窗关闭事件注入dialog，@close="close"
 * 可传入参数自定义form名称，使用方法如下：
 * const mixin = new MyMixin({form:"formName"});
 */
import base from "../base";
import utils from "../utils";

export function CustomForm(params) {
  let data = Object.assign({ form: "form" }, params);
  return {
    data() {
      return {
        form: {}, // 表单元素，用作添加或修改
        parentForm: {}, // 父级表单元素，用于行内新增
        isTrim: true, // 表单是否去空格
        btnLoading: false, // 按钮loading防止用户多次提交
        dialogVisible: false, // 弹窗控制显隐
        customForm: null, // 自定义请求传入表单
        dialogStatus: "create", // 当前弹窗操作状态
        dialogProps: {
          // 弹窗基础设置
          "close-on-click-modal": false,
          class: "ly-c-dialog",
          width: "600px",
        },
        formProps: {
          // 表单基础设置
          "label-position": "right",
          "label-width": "auto",
          class: "ly-c-form full",
          size: "small",
        },
        titleType: {
          add: "新增",
          edit: "编辑",
          view: "查看",
        },
        requestHeaders: {},
        isFirst: true,
      };
    },
    computed: {
      isDisable() {
        return this.dialogStatus === "details";
      },
      dialogTitle() {
        let type = "";
        switch (this.dialogStatus) {
          case "create":
            type = "add";
            break;
          case "update":
            type = "edit";
            break;
          case "details":
            type = "view";
            break;
        }
        return this.titleType[type];
      },
      cancelText() {
        let type = this.isDisable ? "返回" : "取消";
        return type;
      },
    },
    methods: {
      // 关闭弹窗事件
      close() {
        this.dialogVisible = false;
        this.customForm = null;
        this.parentForm = {};
      },
      setKeyEmpty(form, key) {
        if (form[key]) this.$set(form, key, null);
      },
      // 打开添加弹窗
      handleCreate(row) {
        this[data.form] = this.$options.data.call(this)[data.form];
        if (row) this.parentForm = { ...row };
        this.dialogStatus = "create";
        this.isFirst = true;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs[data.form].clearValidate();
        });
        if (this.handleCreateExtend) this.handleCreateExtend(row);
      },
      // 打开修改弹窗
      handleUpdate(row) {
        // this.form = Object.assign({}, row);
        this.dialogStatus = "update";
        this.isFirst = true;
        base.detail(this.moduleUrl, row.uuid || row.id).then((res) => {
          if (res.code === "00000") {
            this[data.form] = utils.formInfoGet(this[data.form], res.data);
            if (this.dialogStatus === "update") {
              this[data.form] = utils.formInfoGet(this[data.form], res.data);
            } else {
              this[data.form] = { ...this[data.form], ...res.data };
            }
            this.dialogVisible = true;
            if (this.handleUpdateExtend)
              this.handleUpdateExtend(this[data.form]);
          }
        });
      },
      // 打开详情弹窗
      handleDetails(row) {
        this.handleUpdate(row);
        this.dialogStatus = "details";
      },
      // 调用新增接口并校验数据
      create(formName, msg, except) {
        if (this.isFirst) {
          this.isFirst = false;
          this.$refs[formName].validate((valid) => {
            if (this.isTrim) utils.formTrim(this[data.form], except || []);
            if (this.createExtend && this.createExtend()) {
              this.isFirst = true;
              return;
            }
            if (valid) {
              this.btnLoading = true;
              base
                .create(
                  this.moduleUrl,
                  this.customForm || this[data.form],
                  this.requestHeaders
                )
                .then((res) => {
                  if (res.code === "00000") {
                    base.showMsg(msg || "新增成功", "success");
                    this.handleAfter();
                  } else {
                    this.customForm = null;
                    this.btnLoading = false;
                    this.isFirst = true;
                  }
                })
                .catch(() => {
                  this.customForm = null;
                  this.btnLoading = false;
                  this.isFirst = true;
                });
            } else {
              this.isFirst = true;
              return false;
            }
          });
        }
      },
      // 调用编辑接口并校验数据
      update(formName, msg, except) {
        if (this.isFirst) {
          this.isFirst = false;
          this.$refs[formName].validate((valid) => {
            if (this.isTrim) utils.formTrim(this[data.form], except || []);
            if (this.updateExtend && this.updateExtend()) {
              this.isFirst = true;
              return;
            };
            if (valid) {
              this.btnLoading = true;
              base
                .update(
                  this.moduleUrl,
                  this.customForm || this[data.form],
                  this.requestHeaders
                )
                .then((res) => {
                  if (res.code === "00000") {
                    base.showMsg(msg || "编辑成功", "success");
                    this.handleAfter();
                  } else {
                    this.customForm = null;
                    this.btnLoading = false;
                    this.isFirst = true;
                  }
                })
                .catch(() => {
                  this.customForm = null;
                  this.btnLoading = false;
                  this.isFirst = true;
                });
            } else {
              this.isFirst = true;
              return false;
            }
          });
        }
      },
      // 接口调用完毕关闭弹窗并请求列表
      handleAfter() {
        if (this.getList) {
          if (this.parentForm.uuid) {
            this.getLazyLoadList(this.parentForm.uuid);
          }
          this.getList();
        } else {
          this.$emit("getList");
        }
        this.btnLoading = false;
        this.dialogVisible = false;
        this.customForm = null;
        this.parentForm = {};
        if (this.handleAfterExtend) this.handleAfterExtend();
      },
      isDataEmpty(res) {
        return res.code === "00000" && res.data;
      },
    },
  };
}

export default new CustomForm();
